/* istanbul ignore file*/
import { Component, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA, MatDialog } from '@angular/material/dialog';
import { ActivatedRoute } from '@angular/router';
import { ADPResourceService } from 'digital-core';
import { ChatHandler } from 'src/app/core/handler/chat-handler';
import { UtilityService } from 'src/app/core/services/utility.service';
import { IClaimModal } from 'src/app/model/sitefinity/IClaimModal';
import { AsappChatService } from '../../../../../core/services/asapp-chat.service';

@Component({
  selector: 'pgh-file-a-claim-modal',
  templateUrl: './file-a-claim-modal.component.html',
  styleUrls: ['./file-a-claim-modal.component.scss'],
})
export class FileAClaimModalComponent {
  constructor(
    public dialogRef: MatDialogRef<FileAClaimModalComponent>,
    @Inject(MAT_DIALOG_DATA) public data: IClaimModal,
    public matDialog: MatDialog,
    public resourceService: ADPResourceService,
    public utilityService: UtilityService,
    private activatedRoute: ActivatedRoute,
    private asappChatService: AsappChatService
  ) {}

  closeModal() {
    this.dialogRef.close();
  }

  onClickChat() {
    // Show chat or not available dialog
    const chatHandler = new ChatHandler(this.matDialog, this.resourceService, this.utilityService, this.activatedRoute, this.asappChatService);
    chatHandler.openChatInterface();
  }
}
